import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseMaintenanceEquipmentPiecesProps<T> = {
  equipmentId: string | undefined;
  filters?: {
    search?: string;
    page?: number;
    brandId?: string;
  };
  mapper?: (data: any) => T;
}

export const useMaintenanceEquipmentPieces = <T,>({
  equipmentId,
  filters: { search = '', page = 1, brandId } = {},
  mapper = Mapper.default<T>(),
}: UseMaintenanceEquipmentPiecesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    enabled: !!equipmentId,
    queryKey: ['maintenanceEquipmentPieces', equipmentId, search, page, equipmentId, brandId],
    queryFn: () => {
      return privateAxios.get(`/maintenance/equipments/${equipmentId}/pieces`, {
        params: {
          search,
          page,
          'q[brand_id_eq]': brandId,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest }
}
